/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** ReadAuthResetResponse — dark-roast DTO: AuthResetsTokenResponseDto */
export const readAuthResetResponseSchema = z.object({ "mfaCodeRequired": z.boolean() });
export type ReadAuthResetResponse = z.infer<typeof readAuthResetResponseSchema>;
